/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMoneyOutTransDetailsInput
 */
export interface GetMoneyOutTransDetailsInput {
    /**
     * Money-Out ID
     * @type {number}
     * @memberof GetMoneyOutTransDetailsInput
     */
    transactionid?: number;
    /**
     * Money-Out Comment
     * @type {string}
     * @memberof GetMoneyOutTransDetailsInput
     */
    transactionComment?: string;
    /**
     * Unique ID Generated by your Server
     * @type {string}
     * @memberof GetMoneyOutTransDetailsInput
     */
    reference?: string;
}

/**
 * Check if a given object implements the GetMoneyOutTransDetailsInput interface.
 */
export function instanceOfGetMoneyOutTransDetailsInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyOutTransDetailsInputFromJSON(json: any): GetMoneyOutTransDetailsInput {
    return GetMoneyOutTransDetailsInputFromJSONTyped(json, false);
}

export function GetMoneyOutTransDetailsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyOutTransDetailsInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionid': !exists(json, 'transactionid') ? undefined : json['transactionid'],
        'transactionComment': !exists(json, 'transactionComment') ? undefined : json['transactionComment'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
    };
}

export function GetMoneyOutTransDetailsInputToJSON(value?: GetMoneyOutTransDetailsInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionid': value.transactionid,
        'transactionComment': value.transactionComment,
        'reference': value.reference,
    };
}

